import { render, staticRenderFns } from "./SetLimit.vue?vue&type=template&id=69ad7891"
import script from "./SetLimit.vue?vue&type=script&lang=js"
export * from "./SetLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports